import React from 'react';
import { FormControlLabel, Checkbox } from '@material-ui/core';
import './CheckboxWithInfo.scss';

const CheckboxWithInfo = ({ checked, label, onChange, disabled, info = "", className = ""}) => {
    return (
        <div className={`checkbox-info-container ${className}`}>
            <div className='checkbox-container'>
                <FormControlLabel
                    classes="label"
                    control={
                        <Checkbox
                            checked={checked}
                            disabled={disabled}
                            onChange={onChange}
                            name="checkedB"
                            color="primary"
                        />
                    }
                    label={label}
                />
            </div>
            <span className='info'>{info}</span>
        </div>
    );
}

export default CheckboxWithInfo;